import { render, staticRenderFns } from "./BUPageTable.vue?vue&type=template&id=16dd70d4&scoped=true&"
import script from "./BUPageTable.vue?vue&type=script&lang=js&"
export * from "./BUPageTable.vue?vue&type=script&lang=js&"
import style0 from "./BUPageTable.vue?vue&type=style&index=0&id=16dd70d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd70d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
